export const GET = "GET";
export const POST = "POST";